import cardSlider from './card-slider.js';
import showCardAdd from './show-card-add.js';
import closeCardAdd from './close-card-add.js';

document.addEventListener('DOMContentLoaded', () => {
    if (!window.cardSlider) {
        window.cardSlider = {};
    }

    cardSlider();

    if (!window.bindShowCardAddEvent) {
        window.bindShowCardAddEvent = bindShowCardAddEvent;
    }

    const oCardItems = document.getElementsByClassName('js-show-card-add');
    Array.from(oCardItems).forEach(bindShowCardAddEvent);
});

function bindShowCardAddEvent(oItem) {
    const oCard = oItem.closest('.card');

    oItem.removeEventListener('click', showCardAdd);
    oItem.addEventListener('click', showCardAdd);

    oCard.removeEventListener('mouseleave', closeCardAdd);
    oCard.addEventListener('mouseleave', closeCardAdd);
}